export const pathEmployeePattern = /^\/employees\/\d+$/;
export const pathClientPattern = /^\/clients\/\d+$/;
export const pathProjectPattern = /^\/projects\/\d+$/;
